import { toDriveDirectUrl } from "@/lib/utils";

export interface Cita {
  id: number;
  texto: string;
  autor?: string;
  cargo?: string;
  sector?: string;
  fecha?: string;
  likes?: number;
  avatar?: string;
}

export interface QuoteCardHorizontalProps {
  cita?: Cita;
}

export default function QuoteCardHorizontal({ cita }: QuoteCardHorizontalProps) {
  if (!cita) {
    return (
      <div className="bg-white rounded-2xl border border-masmed-gray-200 shadow-sm p-4 md:p-5 flex flex-col gap-3 md:gap-4 min-h-[140px]">
        <div className="flex items-start gap-3 md:gap-4">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-masmed-gray-100 flex-shrink-0" />
          <div className="flex-1 min-w-0 space-y-2 pt-0.5">
            <div className="w-24 h-3 bg-masmed-gray-100 rounded" />
            <div className="w-16 h-2 bg-masmed-gray-100 rounded" />
          </div>
        </div>
        <div className="w-full h-8 bg-masmed-gray-100 rounded" />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-masmed-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200 p-4 md:p-5 flex flex-col gap-3 md:gap-4">
      {/* Top row: avatar + nombre/fecha */}
      <div className="flex items-start gap-3 md:gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-primary p-0.5 flex-shrink-0">
          <img
            src={toDriveDirectUrl(cita.avatar || "")}
            alt={cita.autor}
            className="w-full h-full rounded-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0 pt-0.5">
          <p className="text-masmed-gray-900 text-sm md:text-base leading-snug"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            {cita.autor}
          </p>
          <p className="text-masmed-gray-400 text-xs mt-0.5">
            {cita.fecha}
          </p>
        </div>
      </div>

      {/* Bottom row: cita */}
      <p className="text-masmed-gray-600 text-sm leading-relaxed">
        {cita.texto}
      </p>
    </div>
  );
}